import { useEffect, useRef } from "react";
import { Container } from "react-bootstrap";
import priceList from "@/data/services/branding/price-list.json";
import infoList from "@/data/services/branding/info-list.json";
import infoData from "@/data/services/branding/branding.json";
import PageSEO from "@/components/common/PageSEO";
import WebBanner from "@/components/service/components/banner/WebBanner";
import Intro from "@/components/service/components/intro/Intro";
import PriceList from "@/components/service/components/price-list/PriceList";
import InfoList from "@/components/service/components/info-list/InfoList";
import SimpleBanner from "@/components/service/components/simple-banner/SimpleBanner";
import BrandingServices from "@/components/service/components/sub-services/BrandingServices";

const Branding = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const ref = useRef<HTMLDivElement>(null);

  const scrollToRef = () => {
    if (ref.current) {
      ref.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <>
      <PageSEO section="services" keyName="branding" />
      <Intro data={infoData} branding={true} />
      <Container style={{ height: "100%" }}>
        <WebBanner onClick={scrollToRef} img={infoData.banner} />
      </Container>

      <div ref={ref}>
        <BrandingServices services={infoData.services} />
      </div>
      <Container style={{ height: "100%" }}>
        <div className="branding-img-wrapper">
          <SimpleBanner img={infoData.img} />
        </div>
        <PriceList data={priceList} />
        <InfoList data={infoList} />
      </Container>
    </>
  );
};

export default Branding;
